<template>
  <div id="app">
    <div v-if="pageMounted">
      <Header />
      <main id="main" role="main">
        <router-view />
      </main>
      <Toast ref="toastComponent" />
      <Noise />
    </div>
  </div>
</template>

<script>
// Components
import Header from '@/components/global/Header'
import Noise from '@/components/global/Noise'
import Toast from '@/components/Toast'

export default {
  name: 'app',
  data() {
    return {
      pageMounted: false
    }
  },
  components: {
    Header,
    Toast,
    Noise
  },
  mounted() {
    this.pageMounted = true
    console.log('Page has been mounted 🚀')
  },
  methods: {
    // Toast!
    // This forwards the toast content to the component, which displays it
    relayToast: function(word, pronunciation, type, definition) {
      this.$refs.toastComponent.showToast(word, pronunciation, type, definition)
    }
  }
}
</script>
